import Image from "next/image";
import Link from "next/link";
import { useTranslations } from "next-intl";
import CollapseItem from "../CollapseItem";

const Footer = () => {
  const t = useTranslations("layout");

  const footerMenu = [
    {
      title: t("user"),
      links: [
        // {
        //   title: t("earnings"),
        //   href: "",
        // },
        // {
        //   title: "Pricing",
        //   href: "",
        // },
        {
          title: t("for_user"),
          href: "/user",
        },
        {
          title: t("community"),
          href: "/community",
        },
        {
          title: t("become-our-ambassador"),
          href: "/become-hyrasapien",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        // {
        //   title: t("hyrasapiens"),
        //   href: "",
        // },
      ],
    },
    {
      title: t("developer"),
      links: [
        {
          title: t("for_developers"),
          href: "/developer",
        },
        {
          title: t("governance"),
          href: "/governance",
        },
      ],
    },
    {
      title: t("enterprise"),
      links: [
        {
          title: t("for_enterprises"),
          href: "/enterprise",
        },
        {
          title: t("for_investors"),
          href: "/enterprise/investor",
        },
      ],
    },
    {
      title: t("about-us"),
      links: [
        {
          title: t("about_us_1"),
          href: "/about-us",
        },
        {
          title: t("roadmap"),
          href: "/roadmap",
        },
      ],
    },
    {
      title: t("hyra-universe"),
      links: [
        // {
        //   title: t("about-hyra"),
        //   href: "",
        // },
        {
          title: t("ecosystem"),
          href: "/ecosystem",
        },

        {
          title: t("news-and-update"),
          href: "/news",
        },
        {
          title: "Lambo ball",
          href: "https://lamboballs.hyra.network/",
          target: "_blank",
          rel: "noopener noreferrer",
        },
      ],
    },
    {
      title: t("resources"),
      links: [
        {
          title: t("docs-sdk"),
          href: "https://docs.hyra.network/docs/overview/",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        {
          title: "SDK",
          href: "https://sdk.hyra.network/",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        {
          title: t("whitepaper"),
          href: "https://whitepaper.hyra.network/?v=1.0",
          target: "_blank",
          rel: "noopener noreferrer",
        },
        {
          title: "Media Kit",
          href: "/media-kit",
        },
        {
          title: t("faqs"),
          href: "/faq",
        },
      ],
    },
  ];

  return (
    <footer
      data-panel
      className="relative w-full bg-[url('/images/backgrounds/bg-footer.png'),linear-gradient(104deg,#599EFF_-8.83%,#06F_27.96%,#6E19EB_103.4%)] [background-color:lightgray] [background-position:0_0,0_0] [background-repeat:repeat,no-repeat] [background-size:1440px_814px,auto]"
    >
      <div className="mx-auto w-full max-w-[1440px] px-4 pb-8 pt-14 md:px-10 md:pb-12 md:pt-20 dk:px-[78px] dk:pt-[120px]">
        <div className="mb-[60px] flex flex-col-reverse items-start justify-between gap-y-6 md:mb-20 xl:mb-[110px] xl:flex-row">
          <div className="flex w-full flex-col flex-wrap justify-center gap-4 pt-4 md:max-xl:flex-row">
            <Link
              href="/en/news/hyra-network-honored-as-technology-startup-of-the-year-at-the-2025-globee-awards-44"
              className="relative aspect-[5.89] h-auto w-full md:w-[389px]"
            >
              <Image src="/images/globee-banner.png" alt="logo" fill />
            </Link>
            {/* <Link
              href="/en/news/hyra-network-wins-prestigious-chairman-s-award-2025-at-witsa-global-ai-summit-63"
              className="relative aspect-[6.27] h-auto w-full md:w-[389px]"
            >
              <Image src="/images/witsa-banner.png" alt="logo" fill />
            </Link> */}
            <Link
              href="/en/news/hyra-network-wins-asian-technology-excellence-award-2025-driving-the-shift-toward-sovereign-ai-67"
              className="relative aspect-[6.27] h-auto w-full md:w-[389px]"
            >
              <Image src="/images/vtea-2025-banner.png" alt="logo" fill />
            </Link>
          </div>
          <div className="hidden items-start gap-10 md:flex">
            {footerMenu.map((item: any, index: number) => (
              <div key={index} className="flex w-[100px] flex-col gap-4">
                <p className="font-open-sans text-sm font-medium text-white/40 xl:text-base">
                  {item.title}
                </p>
                {item.links.map((link: any, indexLink: number) => (
                  <Link
                    key={indexLink}
                    href={link.href}
                    target={link.target}
                    rel={link.rel}
                    className="text-sm text-white hover:text-white/80 xl:text-base"
                  >
                    {link.title}
                  </Link>
                ))}
              </div>
            ))}
          </div>
          <div className="w-full flex-1 md:hidden">
            {footerMenu.map((item: any, index: number) => (
              <CollapseItem key={index} item={item} />
            ))}
          </div>
        </div>
        <div className="mb-8 flex flex-col items-center justify-between gap-6 xl:mb-[64px] xl:flex-row xl:items-end">
          <p className="text-[70px]/[70px] font-semibold tracking-[-3.205px] text-white md:text-[90px]/[90px] xl:max-w-[630px] xl:text-[128px]/[128px]">
            HYRA NETWORK
          </p>
          <div className="grid w-full grid-cols-2 gap-x-4 max-md:gap-y-2 md:grid-cols-3 md:gap-x-6 xl:block xl:w-[356px]">
            {/* <Link
              href="/"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white xl:text-base">
                LinkedIn
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link> */}
            {/* <Link
              href="/"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white xl:text-base">
                Instagram
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link> */}
            <Link
              href="https://www.facebook.com/hyranetwork"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white hover:text-white/80 xl:text-base">
                Facebook
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link>
            <Link
              href="https://x.com/hyranetwork"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white hover:text-white/80 xl:text-base">
                X/Twitter
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link>
            <Link
              href="https://www.youtube.com/@Hyranetwork"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white hover:text-white/80 xl:text-base">
                YouTube
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link>
            <Link
              href="https://t.me/hyranetwork"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white hover:text-white/80 xl:text-base">
                Telegram
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link>
            <Link
              href="https://discord.com/invite/gpA2puzPyq"
              target="_blank"
              rel="noopener noreferrer"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white hover:text-white/80 xl:text-base">
                Discord
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link>
            {/* <Link
              href="/"
              className="flex w-full items-center justify-between border-b border-solid border-b-[rgba(255,255,255,0.12)] py-1"
            >
              <p className="text-sm font-medium text-white xl:text-base">
                GitHub
              </p>
              <div className="p-2">
                <Image
                  src="/images/icons/array-arrow.svg"
                  alt="array-arrow"
                  width={36}
                  height={20}
                />
              </div>
            </Link> */}
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-4">
          {/* <div className="flex items-center gap-6 xl:gap-10">
            <Link
              href="/"
              className="text-sm font-medium text-white xl:text-base"
            >
              {t("term-of-use")}
            </Link>
            <Link
              href="/"
              className="text-sm font-medium text-white xl:text-base"
            >
              {t("privacy-policy")}
            </Link>
            <Link
              href="/"
              className="text-sm font-medium text-white xl:text-base"
            >
              {t("cookie-policy")}
            </Link>
          </div> */}
          <p className="text-sm font-medium text-white xl:text-base">
            {/* {t("copyright")} */}© 2025 - 2026 Hyra Network. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
